// extracted by mini-css-extract-plugin
export default {"select":"dropdown_select__GMFZH"};